<template>
<div >
    <br>
<div class="row" >

<div v-for="contenido in contenidos" :key="contenido.index" class="caja-tarjeta col-12 col-md-12 col-sm-12 col-lg-6" :class="columnasDeContenido(contenido.TamanoDeLaColumna)" style="width: 18rem;">
<div v-if="!validaRuta(contenido.RutaDeArchivo)" class="caja-video"  >
<video class="video"   controls preload="auto">
   <source :src="contenido.RutaDeArchivo" />
  <img src="imagen.png" alt="Video no soportado" />
  Su navegador no soporta contenido multimedia.
</video>
</div>
 <div v-else class="caja-video">
     <iframe width="100%" height="100%" :src="rutaEmbed(contenido.RutaDeArchivo)" 
     frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
     allowfullscreen></iframe>
 </div>
  <div class="caja-texto" >
      <h2 class="titulo">{{contenido.TextoDelVinculo}}</h2> 
      <h2 class="descripcion">{{contenido.TextoDelContenido}}</h2>    
  </div>
</div>

    </div>
</div>
</template>

<script>
export default {
    props:{
        contenidos: Array
    },
    methods:{
 
        rutaEmbed:function(ruta){
            let clave="";
            if(ruta.includes("watch")){
                clave=ruta.split("=")[1]
            }
            else if(ruta.includes("iframe")){
                clave=ruta.split(" ")[3].split("/").pop().replace('"','');
            }
            else if(ruta.includes("embed")){
                clave=ruta.split('/')[4]
            }
            else if(ruta.includes("youtu.be")){
                clave = ruta.split('/')[3];
            }
    ruta = "https://www.youtube.com/embed/"+clave;
    return ruta;



        },
        validaRuta:function(ruta){
            if(ruta.includes("youtube")) return true
            if(ruta.includes("youtu.be")) return true
            else return false

        },
        columnasDeContenido(columnas){
            var respuesta = 'col-xl-'+columnas;      
            return respuesta
        },
        rutaVideo(ruta){
            var datosVideo = {'Ruta':ruta,'Play':1}
            this.$store.dispatch("A_SICPO_Micrositio_RutaVideo",datosVideo); 
        }

    }
}
</script>

<style scoped>
.caja-video{
       height: 50vh;
}
.caja-texto{
    background-color:rgb(245, 242, 242);
    padding: 1em;
    width:100%;
    display:block;
    margin:auto;
}
.titulo{
font-size: 2em;
text-align: justify;
 font-family: 'AntenaBeta';
}
.descripcion{
font-size: 1.3em;
 font-family:'Myriad';
text-align: justify;
    padding: .5rem;
    border-radius: 9px;
}


.play{
  position: absolute;
    opacity:.7;
    text-align:center;
    background-color: #000000;
    right: 45%;
    top: 15%;
    padding-right: 2em;
    padding-left: 2em;
    padding-top: 1em;
    padding-bottom: 1em;
    border-radius: 15px;
    color: white;

}
.play:hover{
    -webkit-transition: opacity .5s ease-in-out;
       -moz-transition: opacity .5s ease-in-out;
        -ms-transition: opacity .5s ease-in-out;
         -o-transition: opacity .5s ease-in-out;
            transition: opacity .5s ease-in-out;
     opacity:1;
}

.imagen{
display:block;
margin:auto;
width:100%;
height:30vh;
margin:auto;
}

.title{
    text-align: center;
    font-size: 20px;
    color: #000000;
    font-weight: 100;
    font-family: 'Roboto', sans-serif;
}

.caja-tarjeta{
    justify-content: center;
    align-items: center;
    margin-bottom: 2vh;
 
   
  

}
.video{
width: 100%;
height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/Video.vue